import Link from 'next/link';
import isObject from 'lodash/isObject';
import { ISocialMediaItem } from '@features/cms/typescript';
import styles from '@components/SocialMedia/SocialMedia.styles';
import theme from '@styles/theme';
import Heading from '@components/Heading/Heading';
import Icon from '@components/icons/Icon';
import { firstUppercase } from '@utils/misc';
import { TIcon } from '@components/icons/typescript';
import scrollToElementById from '@utils/scrollToElementById';
import prepareURLByCMSLink from '@utils/prepareURLByCMSLink';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  mediaItem: ISocialMediaItem;
};
const SocialMediaItem = ({
  mediaItem
}: PropsType) => {
  const {
    link,
    text,
    image,
    textColor,
    icon,
    iconColor,
    blur
  } = mediaItem;
  const href = isObject(link) ? prepareURLByCMSLink(link) : link;
  const imageAlt = typeof image !== 'string' ? image?.metadata?.alt || text : text;
  const handleKeyDown = (e: React.KeyboardEvent, targetHref: string) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      scrollToElementById(targetHref.substring(1));
    }
  };
  const renderContent = () => <div sx={styles.socialMediaItemContainer}>
      {image && <ResponsiveImage image={image} alt={imageAlt} blur={typeof blur === 'string' ? blur : undefined} />}
      <div sx={styles.socialMediaTextContainer}>
        <Heading h={4} headingType={4} mobile align="center" color={textColor || theme.rawColors.neutralWhite}>
          {text}
        </Heading>
        <Icon icon={firstUppercase(icon) as TIcon} size="55px" margin="0 auto" color={iconColor || theme.rawColors.neutralWhite} title={text} />
      </div>
    </div>;
  return <div sx={styles.socialMediaItemLinkContainer} data-cy="SocialMediaContainer">
      {href ? <>
          {href.slice(0, 1) === '#' ? <span onClick={() => scrollToElementById(href.substring(1))} onKeyDown={e => handleKeyDown(e, href)} role="button" tabIndex={0}>
              {renderContent()}
            </span> : <Link href={href || '#'} aria-label={text} role="button" tabIndex={0} sx={styles.socialMediaItemContainerLink}>
              {renderContent()}
            </Link>}
        </> : <span onClick={() => scrollToElementById(href?.substring(1))} onKeyDown={e => handleKeyDown(e, href)} role="button" tabIndex={0}>
          {renderContent()}
        </span>}
    </div>;
};
export default SocialMediaItem;